import React, { useEffect, useState } from "react";
import { AuthRecordingDataAction } from "./actions/recordingAuthActions";
import RecordingUI from "./views/RecordingUI";
import { Navigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AlertSessionLayout from "../../general/components/Alert/AlertSessionLayout";

export default function RecordingModul() {
  console.log("Recording UIcall Index");

  const store = useSelector((state) => state.recordingmodul_user_data);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const dataBase64 = searchParams.get("data");
  useEffect(() => {
    if (dataBase64 != null) {
      console.log("data", dataBase64);
      dispatch(AuthRecordingDataAction(dataBase64));
    } else {
      setLoading(false);
    }
  }, [dataBase64]);
  useEffect(() => {
    if (store.success) {
      setLoading(false);
    }
    if (store.error) {
      console.log("Here error store");
      console.log("store", store);
    }
  }, [store]);
  return (
    <>
      <div className="bg-black">
        {loading == false && (
          <>
            {store.data.token != null && typeof store.data.token == "string" ? (
              <>
                <RecordingUI />
                <AlertSessionLayout />
              </>
            ) : (
              <Navigate to="/404" />
            )}
          </>
        )}
      </div>
    </>
  );
}
